<template>
  <div class="home-container">
    <Banner />
    <Shop />
    <Case />
    <Service />
  </div>
</template>

<script>
import Banner from './Banner.vue'
import Shop from './Shop.vue'
import Case from './Case.vue'
import Service from './Service.vue'

export default {
  name: 'HomeView',
  components: {
    Banner,
    Shop,
    Case,
    Service
  }
}
</script>
